import {
    SEARCH_VERSION_PREFERENCE_STORAGE_KEY,
    SearchVersionPreference,
} from 'shared/const/searchVersionPreference';

const isValidPreference = (
    value: string | null,
): value is Exclude<SearchVersionPreference, 'auto'> =>
    value === 'v1' || value === 'v2';

export const readSearchVersionPreferenceFromStorage =
    (): SearchVersionPreference => {
        const stored = localStorage.getItem(
            SEARCH_VERSION_PREFERENCE_STORAGE_KEY,
        );

        if (isValidPreference(stored)) {
            return stored;
        }

        return 'auto';
    };

export const writeSearchVersionPreferenceToStorage = (
    preference: SearchVersionPreference,
): void => {
    if (preference === 'auto') {
        localStorage.removeItem(SEARCH_VERSION_PREFERENCE_STORAGE_KEY);
        return;
    }

    localStorage.setItem(SEARCH_VERSION_PREFERENCE_STORAGE_KEY, preference);
};

export const getSearchVersionPreferenceHeaderValue = (
    preference: SearchVersionPreference,
): SearchVersionPreference | null => {
    if (preference === 'auto') {
        return null;
    }

    return preference;
};
